import { SvgInline } from "../../SvgInline/SvgInline";
import styles from "./payment-methods.module.scss";

export const AutoPayment = ({ paymentInfo, commonData }) => (
  <>
    <div className={styles.headText}>
      The automatic payment facility helps to ensure you never miss a payment by
      setting up automatic monthly payments to your account from your savings or
      cheque account.
    </div>
    <div role="table" className={styles.table}>
      <div role="row" className={styles.row}>
        <div role="cell" className={styles.label}>
          Form
        </div>
        <div role="cell">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={paymentInfo.form_url}
            download
          >
            Download Request Form{" "}
            <SvgInline name="icon-download" strokeBlueBright />{" "}
          </a>
        </div>
      </div>
      <div role="row" className={styles.row}>
        <div role="cell" className={styles.label}>
          Account number
        </div>
        <div role="cell">{commonData.accountNumber}</div>
      </div>
    </div>
    <div className="body03">
      <p>
        If you make only the minimum payment each month, you will pay more
        interest and it will take you longer to pay off your balance.
      </p>
    </div>
  </>
);
